import { Routes, mapToCanActivate } from "@angular/router";

import { BaseGuardService } from "../auth/guards/base-guard.service";

import { WellViewerComponent } from "./components/well-viewer/well-viewer.component";

const routeGuards = [BaseGuardService];


export const GIS_ROUTES: Routes = [
    { path: "well-viewer", component: WellViewerComponent, canActivate: mapToCanActivate(routeGuards) }
];
